export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10762.e4a46a79.jpg";